export default __webpack_public_path__ + "static/media/graphic.f8dd2e42.svg";